import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Maximize2 } from "react-feather";
import FitPagedView from "./FitPagedView";

/**
 * One report on the Petty Cash Overview: a header (title, count, its own
 * controls and Print/Export), then the report in a fixed-height box that
 * scrolls on its own. The full-screen button opens the same report in a
 * full-screen modal cut into pages that fit the screen, so nobody has to
 * leave the page to read a report properly.
 *
 * `renderSection()` draws the scrolling version; `fit` = { items, split?,
 * renderPage(pageItems), noun } the paged one. Both read the page's data, so
 * opening full screen fetches nothing.
 */
const OverviewSection = ({
  title,
  icon: Icon,
  count,
  headerExtra,
  actions,
  subtitle,
  status,
  height = "42vh",
  renderSection,
  fit,
  emptyText = "Nothing matches these filters.",
}) => {
  const [isFull, setIsFull] = useState(false);
  const isEmpty = !fit.items.length;

  const header = (inModal) => (
    <div className="pc-section-head">
      <div className="d-flex align-items-center gap-2 me-auto">
        {Icon && <Icon size={17} className="text-primary" />}
        <h5 className="mb-0">{title}</h5>
        {count != null && <span className="badge rounded-pill bg-light text-dark border">{count}</span>}
        {status && <small className="text-muted">{status}</small>}
      </div>
      {headerExtra}
      {actions}
      {!inModal && (
        <button type="button" className="btn btn-sm btn-outline-secondary" title="Full screen" onClick={() => setIsFull(true)}>
          <Maximize2 size={15} />
        </button>
      )}
    </div>
  );

  return (
    <>
      <div className="card pc-section">
        {header(false)}
        <div className="pc-section-body" style={{ height }}>
          {isEmpty ? <div className="text-center text-muted py-5">{emptyText}</div> : renderSection()}
        </div>
      </div>

      {isFull && (
        <Modal show fullscreen onHide={() => setIsFull(false)} className="pc-fullscreen">
          <Modal.Header closeButton>
            <div className="w-100">
              {header(true)}
              {subtitle && <div className="small text-muted mt-1">{subtitle}</div>}
            </div>
          </Modal.Header>
          <Modal.Body>
            <FitPagedView items={fit.items} split={fit.split} renderPage={fit.renderPage} noun={fit.noun} emptyText={emptyText} />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default OverviewSection;
